import { Field } from 'react-final-form'

import { DropdownPicker, DropdownPickerProps } from '../../components/DropdownPicker'
import { FormControl } from '../../components/FormControl'

export type DropDownPickerFieldProps = {
  name: string
  additionalProps?: DropdownPickerProps
}

export const DropDownPickerField = ({ name, additionalProps }: DropDownPickerFieldProps) => {
  return (
    <Field
      name={name}
      render={p => {
        return <FormControl<DropdownPickerProps> {...p} component={DropdownPicker} additionalProps={additionalProps} />
      }}
    />
  )
}
